export default __webpack_public_path__ + "static/media/094-turkey.bd3df11c.svg";